import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {config, defaultErrorHandler} from '../../../context/context';
import {InitialValueType} from './initial-value/initial-value';
import SelectField from '../../../libs/react-components-admin/fields/select-field';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';
import FieldLabel from './field-label';
import FieldHelpText from './field-help-text';
import FieldMandatory from './field-mandatory';
import FieldWidth from './field-width';
import ConditionId from './condition-id';
import FieldPlaceholder from './field-placeholder';

const DefaultCountryCode = ({idPrefix, value, onChange}) => {

  const [_value, setValue] = useState(value || 'US');
  const [countryCodes, setCountryCodes] = useState();

  useEffect(() => { onChange(_value); }, [_value]);

  useEffect(() => {
    axios.get(`${config.clientUrl}/data/phone-country-codes.json`)
      .then(({data}) => setCountryCodes((data || [])
        .map(row => ({label: `${row[1]} (+${row[2]})`, value: row[0]}))
      ))
      .catch(defaultErrorHandler);
  }, []);

  if (!countryCodes) {
    return <CenteredSpinner/>;
  }
  return <SelectField id={`${idPrefix}-default-country-code`}
                      label="Default country code"
                      values={countryCodes}
                      value={_value}
                      onChange={v => setValue(v)}/>
};

const InitialValue = ({idPrefix, value, onChange}) => {

  const [_value, setValue] = useState(value || {});

  useEffect(() => { onChange(_value.type ? {type: _value.type} : null); }, [_value]);

  return <div className="form-check mb-3">
    <input type="checkbox"
           id={`${idPrefix}-initial-value`}
           className="form-check-input"
           checked={_value.type === InitialValueType.SHOPIFY_CUSTOMER_PHONE_NUMBER}
           onChange={e => setValue({
             type: e.target.checked ?
               InitialValueType.SHOPIFY_CUSTOMER_PHONE_NUMBER :
               null
           })}/>
    <label className="form-check-label" htmlFor={`${idPrefix}-initial-value`}>
      Prepopulate with the customer&apos;s phone number (only available if your customer is logged in)
    </label>
  </div>;
};

const PhoneNumberField = ({id, conditions, value, onChange}) => {

  const [model, setModel] = useState(value || {});
  const [_conditions, setConditions] = useState(conditions);

  useEffect(() => { onChange(model); }, [model]);
  useEffect(() => { setConditions(conditions); }, [conditions]);

  return <div>
    <FieldLabel value={model.label}
                onChange={v => setModel({...model, label: v})}/>
    <FieldPlaceholder value={model.placeholder} onChange={v => setModel({...model, placeholder: v})}/>
    <FieldHelpText value={model.helpText} onChange={v => setModel({...model, helpText: v})}/>
    <FieldMandatory id={id}
                    value={model.mandatory}
                    onChange={v => setModel({...model, mandatory: v})}
                    conditionallyDisplayed={!!model.conditionId}/>
    <FieldWidth value={model.widthInPercent} onChange={v => setModel({...model, widthInPercent: v})}/>
    <DefaultCountryCode idPrefix={id}
                        value={model.defaultCountryCode}
                        onChange={v => setModel({...model, defaultCountryCode: v})}/>
    <InitialValue idPrefix={id}
                  value={model.initialValue}
                  onChange={v => setModel({...model, initialValue: v})}/>
    <ConditionId id={id}
                 conditions={_conditions}
                 value={model.conditionId}
                 onChange={v => setModel({...model, conditionId: v})}/>
  </div>
};

export default PhoneNumberField;
